import React, { Component, Fragment } from 'react';
import styled, { css } from "styled-components";
import Truncate from "react-truncate";
import { Preamble } from "../styles/Preamble";
import connect from "../store/connect";

class TruncatedPreamble extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExtended: false,
      isTruncated: false,
    };
  }
  
  onTruncateHandler(isTruncated) {
    if (isTruncated !== this.state.isTruncated) {
      this.setState({ isTruncated })
    }
  }
  
  onExtendHandler() {
    this.setState(currentState => ({ isExtended: !currentState.isExtended }))
  }
  
  render() {
    const { isExtended, isTruncated } = this.state;
    const rowsToShow = this.props.pageWidth > 768 ? 4 : 5;
    
    return (
      <Fragment>
        <DesignerPreamble isExtended={isExtended} isTruncated={isTruncated}>
          <Truncate lines={isExtended ? 0 : rowsToShow} onTruncate={isTruncated => this.onTruncateHandler(isTruncated)}>
            {this.props.children}
          </Truncate>
        </DesignerPreamble>
        
        {isTruncated || isExtended ?
          <ReadMoreButton onClick={() => {this.onExtendHandler()}}>
            {isExtended ? 'Visa mindre −' : 'Visa mer +'}
          </ReadMoreButton>
          : false
        }
      </Fragment>
    );
  }
}

const DesignerPreamble = Preamble.extend`
  overflow: hidden;
  position: relative;
  margin-bottom: 0 !important;
  transition: border .25s ease-out, opacity .25s ease-out;
  
  &:after {
    content: "";
    display: block;
    position: absolute;
    top: 30%;
    right: 0;
    bottom: 0;
    left: 0;
    background: linear-gradient(
      to top,
      hsl(0, 0%, 95%),
      hsla(0, 0%, 95%, 0.94505) 7.9%,
      hsla(0, 0%, 95%, 0.88294) 15.3%,
      hsla(0, 0%, 95%, 0.81522) 22.2%,
      hsla(0, 0%, 95%, 0.7426) 28.7%,
      hsla(0, 0%, 95%, 0.66692) 34.8%,
      hsla(0, 0%, 95%, 0.58891) 40.6%,
      hsla(0, 0%, 95%, 0.50925) 46.2%,
      hsla(0, 0%, 95%, 0.42866) 51.7%,
      hsla(0, 0%, 95%, 0.34817) 57.2%,
      hsla(0, 0%, 95%, 0.2693) 62.8%,
      hsla(0, 0%, 95%, 0.19309) 68.7%,
      hsla(0, 0%, 95%, 0.12126) 75.2%,
      hsla(0, 0%, 95%, 0.05882) 82.6%,
      hsla(0, 0%, 95%, 0.01457) 91.2%,
      hsla(0, 0%, 95%, 0)
    );
  }
  
  ${props => (props.isExtended || !props.isTruncated) && css`
    max-height: initial;
    margin-bottom: 10px !important;
    &:after {
      display: none;
    }
  `}
`;

const ReadMoreButton = styled.button`
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  text-transform: uppercase;
  font-weight: 600;
  background-color: transparent;
  display: block;
  border: none;
  margin: 0 auto 0;
  width: auto;
  padding: 10px;
  font-size: 14px;
  cursor: pointer;
  transition: opacity .25s ease-out;
  
  &:focus {
    outline: 0;
  }
  
  &:hover {
    opacity: .65;
  }
`;

export default connect(TruncatedPreamble, {}, store => ({
  pageWidth: store.viewstate.get('pageWidth')
}));



// WEBPACK FOOTER //
// ./src/components/TruncatedPreamble.js